
import { LockDec } from '@/decorators';
import { TSX, Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import EditItem from './edit-item.vue';
import { getFormTypeName } from './form-type';
interface Props { };
@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  list = [];

  submitLoading = false;

  editRow(row) {
    return this.$dialog({
      title: row.id ? '编辑字段' : '新增字段',
      props: { width: '600px' },
      content: () => <EditItem modelValue={row} />,
    }, 's')
  }

  async editItem(i) {
    let data = await this.editRow(this.list[i]);
    if (!data) return;
    this.list[i] = data;
  }

  async addItem() {
    let data = await this.editRow({
      name: '',
      placeholder: '',
      type: 1,
      isRequire: 0,
      isEnabled: 1,
      content: null,
    });
    if (!data) return;
    this.list.push(data);
  }

  removeItem(i) {
    this.list.splice(i, 1)
  }

  swapArray(arr, index1, index2) {
    if (index1 < 0 || index1 >= arr.length || index2 < 0 || index2 >= arr.length) {
      return;
    }
    let temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
  }

  upIndex(i) {
    this.swapArray(this.list, i, i - 1)
  }

  downLindex(i) {
    this.swapArray(this.list, i, i + 1)
  }

  created() {
    this.getList()
  }

  changeRequire(row, val) {
    row.isRequire = val;
    if (row.isRequire == 1) {
      row.isEnabled = 1;
    }
  }

  changeEnabled(row, val) {
    row.isEnabled = val;
    if (row.isEnabled == 0) {
      row.isRequire = 0;
    }
  }

  getFormatType(type) {
    return getFormTypeName(type);
  }

  async getList() {
    let { error, data } = await this.$post("/manager/store/order-form-list")
    if (error) return;
    this.list = data.list;
  }

  @LockDec("submitLoading")
  async submitForm() {
    let data = await this.$postNotify("/manager/store/set-order-form", {
      list: this.list
    });
    this.list = data;
    this.$emit("resolve")
  }
  cancel() {
    this.$emit("reject")
  }
}
